
import { loadHbridge } from '@/utils/globalLoader';

const _UBTCache = {};
export async function getUBTCache() {
  const { Native } = await loadHbridge();
  try {
    const cache = await Native.callNative({
      classMap: 'SwitchBridge',
      method: 'getUBTCache',
    });
    return cache;
  } catch (e) {
    return _UBTCache;
  }
}

export async function setUBTCache(cache) {
  try {
    if (!cache) return;
    if (Object.keys(cache).length === 0) return;
    const { Native } = await loadHbridge();
    await Native.callNative({
      classMap: 'SwitchBridge',
      method: 'setUBTCache',
      params: cache,
    });
  } catch (e) {
    Object.assign(_UBTCache, cache);
  }
}
